// Query selector
function qs(selector, parent = document) {
	return parent.querySelector(selector)
}

// Query selector all
function qsa(selector, parent = document) {
	return [...parent.querySelectorAll(selector)]
}

// Add event listener
function addGlobalEventListener(
	type,
	selector,
	callback,
	options,
	parent = document
) {
	parent.addEventListener(
		type,
		(e) => {
			if (e.target.matches(selector)) callback(e)
		},
		options
	)
}

// First of array
function first(array, n = 1) {
	if (n === 1) return array[0]
	return array.filter((_, index) => index < n)
}

// Last of array
function last(array, n = 1) {
	if (n === 1) return array[array.length - 1]
	return array.filter((_, index) => array.length - index <= n)
}

// Random item from array
function sample(array) {
	return array[randomNumberBetween(0, array.length - 1)]
}

//Update URL when changing Product Variant

function updateQueryString(key, value, url) {
	if (!url) {
		url = window.location.href
	}

	let updated = ''
	var re = new RegExp('([?&])' + key + '=.*?(&|#|$)(.*)', 'gi'),
		hash

	if (re.test(url)) {
		if (typeof value !== 'undefined' && value !== null) {
			updated = url.replace(re, '$1' + key + '=' + value + '$2$3')
		} else {
			hash = url.split('#')
			url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '')
			if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
				url += '#' + hash[1]
			}
			updated = url
		}
	} else {
		if (typeof value !== 'undefined' && value !== null) {
			var separator = url.indexOf('?') !== -1 ? '&' : '?'
			hash = url.split('#')
			url = hash[0] + separator + key + '=' + value
			if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
				url += '#' + hash[1]
			}
			updated = url
		} else {
			updated = url
		}
	}

	window.history.replaceState({ path: updated }, '', updated)
}

/* Change Product Quantity */
function changeQuantity(formId, quantity) {
	var formQ = document.querySelector(formId)

	if (quantity == '+') {
		Number(formQ.value++)
	} else if (quantity == '-' && formQ.value > 1) {
		Number(formQ.value--)
	}
}

function cartToggle(type) {
	if (type == 'open') {
		body.classList.add('js-my-cart-open')
		body.classList.add('disable-scroll')
	} else if (type == 'close') {
		body.classList.remove('js-my-cart-open')
		body.classList.remove('disable-scroll')
	} else {
		body.classList.toggle('js-my-cart-open')
		body.classList.toggle('disable-scroll')
	}
}
function searchToggle(type) {
	if (type == 'open') {
		body.classList.add('search-modal-open')
		body.classList.add('disable-scroll')
	} else if (type == 'close') {
		body.classList.remove('search-modal-open')
	} else {
		body.classList.toggle('search-modal-open')
		body.classList.toggle('disable-scroll')
	}
}

function navToggle(type) {
	if (type == 'open') {
		header.classList.add('active')
		mobileNavigation.classList.add('active')
		body.classList.add('disable-scroll')
	} else if (type == 'close') {
		header.classList.remove('active')
		mobileNavigation.classList.remove('active')
	} else {
		header.classList.toggle('active')
		mobileNavigation.classList.toggle('active')
		body.classList.toggle('disable-scroll')
	}
}

/* Toggle Active (Generic) */
function toggleActive(modalName, parent = document) {
	var modalActive = parent.querySelector(modalName)
	modalActive.classList.toggle('active')
}

function formatMoney(originalPrice, newPrice, quantity = 1) {
	const currency = originalPrice.charAt(0)
	return currency + ((newPrice / 100) * quantity).toFixed(2)
}

function changeCardQuantity(card, action) {
	const input = qs('[data-quantity-input]', card)
	const priceEl = qs('[data-regular-price]', card)
	const subPriceEl = qs('[data-sub-price]', card)

	const priceOg = priceEl.getAttribute('data-price')

	let subPrice = null
	if (subPriceEl) {
		subPrice = subPriceEl.getAttribute('data-price')
	}

	if (input.value == 0) {
		return
	}

	if (action == 'plus') {
		Number(input.value++)
	} else {
		if (input.value > 1) {
			Number(input.value--)
		}
	}

	priceEl.innerHTML = `$${((priceOg / 100) * Number(input.value)).toFixed(2)} `
	if (subPriceEl) {
		subPriceEl.innerHTML = `$${((subPrice / 100) * Number(input.value)).toFixed(
			2
		)}`
	}
}
